// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".proposals-grid[data-v-5a0ee982] {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(calc(50% - 15px), 1fr));\n  grid-column-gap: 15px;\n  grid-row-gap: 15px;\n  box-sizing: border-box;\n  width: 100%;\n}\n@media screen and (max-width: 1024px) {\n.proposals-grid[data-v-5a0ee982] {\n    grid-template-columns: repeat(1, 1fr);\n}\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
